const getComponentName = () => {
  try {
    const stack = new Error().stack;
    const lines = stack.split('\n');
    
    // Look for the first line that contains our source files (skip Error constructor and logger calls)
    for (let i = 2; i < lines.length; i++) {
      const line = lines[i].trim();
      
      // Skip lines that are from the logger itself, node_modules, or bundle.js
      if (line.includes('logger.js') || 
          line.includes('node_modules') || 
          line.includes('bundle.js') ||
          line.includes('Object.log') ||
          line.includes('Object.logAlways') ||
          line.includes('Object.error')) {
        continue;
      }
      
      // Try to extract file name and function name
      // Pattern 1: "at FunctionName (file.js:line:column)"
      let match = line.match(/at\s+(\w+)\s+\(([^)]+)\)/);
      if (match) {
        const functionName = match[1];
        const filePath = match[2];
        // Extract just the filename from the path
        const fileName = filePath.split('/').pop().split('?')[0].split(':')[0];
        return `${fileName}:${functionName}`;
      }
      
      // Pattern 2: "at file.js:line:column" (anonymous function)
      match = line.match(/at\s+([^:]+):(\d+):(\d+)/);
      if (match) {
        const filePath = match[1];
        const fileName = filePath.split('/').pop().split('?')[0];
        return fileName;
      }
      
      // Pattern 3: "at FunctionName" (simple function name) - but be more careful
      match = line.match(/at\s+(\w+)/);
      if (match) {
        const functionName = match[1];
        // Skip common internal function names
        if (['Object', 'Array', 'Function', 'String', 'Number', 'Boolean', 'Date', 'RegExp'].includes(functionName)) {
          continue;
        }
        return functionName;
      }
    }
    
    return 'Unknown';
  } catch (e) {
    return 'Unknown';
  }
};

// Create logger function
const createLogger = (loggingEnabled = false, componentName = null) => {
  const getDisplayName = () => {
    // If component name is provided, use it
    if (componentName) {
      return componentName;
    }
    // Otherwise try to auto-detect
    return getComponentName();
  };

  return {
    log: (...args) => {
      if (loggingEnabled) {
        const displayName = getDisplayName();
        console.log(`[${displayName}]`, ...args);
      }
    },
    logAlways: (...args) => {
      // This will log regardless of environment
      const displayName = getDisplayName();
      console.log(`[${displayName}]`, ...args);
    },
    error: (...args) => {
      // You might want to keep error logs even in production
      const displayName = getDisplayName();
      console.error(`[${displayName}]`, ...args);
    }
  };
};

// Default logger instance for backward compatibility
const createDebugLogger = createLogger(process.env.REACT_APP_ENV === 'DEVELOPMENT');


export { createLogger, createDebugLogger };
export default { createLogger, createDebugLogger };